import { Routes } from '@angular/router';
import { CategoryListComponent } from './category-list';
import { EditCategoryComponent } from './edit-category';

export const ROUTES: Routes = [
  {
    path: '',
    component: CategoryListComponent
  },
  {
    path: 'edit/:id',
    component: EditCategoryComponent
  },
  {
    path: 'add/:parentId',
    component: EditCategoryComponent
  },
  {
    path: 'add',
    component: EditCategoryComponent
  }
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/+category/category.routes.ts